// extracted by mini-css-extract-plugin
export var center = "_h-2";
export var clickableRow = "_h-5";
export var expandedRow = "_h-7";
export var hoverable = "_h-4";
export var left = "_h-1";
export var right = "_h-3";
export var row = "_h-0";
export var selectedRow = "_h-6";
export var summaryRow = "_h-8";